<template>

  <div class="confirmation" v-if="orderInfo">


    <div class="block select-room">
      <div class="block-head">
        {{$t('Reservation Confirmation')}}
      </div>
      <div class="block-content">
        <div class="infor-wrapper">
          <h2>{{$t('Dear')}} {{userInfo.name}},</h2>
          <p class="wel-notes">{{$t('wel-notes')}}</p>
          <div class="room-infor">
            <ul>
              <li><label>{{$t('Arrival Date')}}:</label><span>{{orderInfo.Arrival_Date}}</span></li>
              <li><label>{{$t('Number of Night')}}: </label><span>{{orderInfo.number_of_night}}</span></li>
              <li><label>{{$t('Adults Per Room')}}:</label><span>{{orderInfo.Adults}}</span></li>
              <li><label>{{$t('Departure Date')}}:</label><span>{{orderInfo.Departure_Date}}</span></li>
              <li><label>{{$t('Number of Rooms')}}:</label><span>{{orderInfo.rooms.length}}</span></li>
              <li><label>{{$t('Child Per Room')}}: </label><span>{{orderInfo.Children}}</span></li>
            </ul>
          </div>
        </div>
        <div class="confirmation-group">
          <div class="group-item" v-for="(roomItem, key) in orderInfo.rooms" :key='key'>
            <div class="block-head second-block-head">
              {{roomItem.Firstname}} {{roomItem.Lastname}}
              <span class="confirmation-number">
                {{$t('Confirmation Number')}}:<strong>{{roomItem.confirmation_number}}</strong>
              </span>
            </div>

            <div class="block-content second-block-content">
              <div class="infor-list">
                <ul>
                  <li>
                    <span>{{roomItem.Hotel_code.name}}</span>
                    <span>{{roomItem.Roomtype_code.name}}</span>
                  </li>
                  <li>
                    <span>{{roomItem.Rate_code.name}}</span>
                    <span v-if="roomItem.patron_id">{{$t('Patron ID')}}: {{roomItem.patron_id}}</span>
                  </li>
                  <li>
                    <span>{{roomItem.Phone}}</span>
                    <span class="email">{{roomItem.Email}}</span>
                  </li>
                </ul>

              </div>
              <div class="request-list">
                <ul>
                  <li v-for="(item, key) in roomItem.Special_codes" :key="key">{{item}}</li>
                  <li class="no-item" v-if="!roomItem.Special_codes.length">{{$t('No special request')}}</li>
                </ul>
                <div class="request-note">
                  <p v-if="roomItem.comments">
                    {{roomItem.comments}}
                  </p>
                  <P v-else>
                    {{$t('No comments')}}
                  </P>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>

    <div class="actions-toolbar">
      <router-link to="/reservation">
        <button class="primary action-submit">
          {{$t('Back To Homepage')}}
        </button>
      </router-link>
    </div>

  </div>

</template>

<script>

  export default {
    props: [],
    data: function () {
      return {}
    },
    methods: {},
    created() {
      if (!this.orderInfo) {
        this.$router.push({path: '/reservation'})
      }
    },
    computed: {
      orderInfo() {
        return this.$store.state.orderConfirmation
      },
      userInfo() {
        return this.$store.state.userInfo
      },

    },

  }

</script>

